class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }
  listeners() {

    this.bindQuantityEvent();
    this.bindSellingPlans();

    // Debounce function to control the browsers throttle
    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
    window.addEventListener('scroll', debounce(this.scrollCheck, 250));
  }

  scrollCheck() {
    let offset;
    // Change value on smaller devices
    const productForm = document.querySelector('.product__form');

    offset = productForm.offsetTop + productForm.offsetHeight;

    // Adds/removes active states
    let stickyAddToCart = document.querySelector('sticky-add-to-cart');
    return (window.pageYOffset > offset ? stickyAddToCart.classList.add('is-active') : stickyAddToCart.classList.remove('is-active'));
  }

  bindQuantityEvent() {
    let quantityMain = document.querySelector('.product .quantity__input'),
      quantityStickyBar = document.querySelector('.js-quick-add-quantity');

    // Update the hidden input quantity field, when the quantity value changes
    if (quantityMain != null && quantityStickyBar != null) {
      quantityMain.addEventListener('change', () => {
        quantityStickyBar.value = quantityMain.value;
      });
    }

  }

  bindSellingPlans() {
    let stickyButton = this.querySelector('product-form button');

    if (stickyButton) {
      stickyButton.addEventListener('click', (e) => {
        let sellingPlan = document.querySelector('.product input[name="selling_plan"]'),
          sellingPlanStickyBar = this.querySelector('.js-selling-plan');

        sellingPlanStickyBar.value = sellingPlan.value;
      });
    }
  }
}
customElements.define('sticky-add-to-cart', StickyAddToCart);